import React, { useEffect, useState } from 'react';

import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import ChartWrapper from '../../../components/Charts/ChartWrapper';
import StackedBarChart from '../../../components/Charts/StackedBarChart';
import useTopTierDistribution from '../../../hooks/dashboard/performance-monitoring/useTopTierDistribution';
import PerformanceChartFilter from './PerformanceChartFilter';

const PerformanceChart = () => {
  const theme = useTheme();

  const { getTopTierDistributionDataInsight, topTierDistributionData } =
    useTopTierDistribution();

  const [dataUrl, setDataUrl] = useState<string>(
    `ba/v1/company/tier-distribution`,
  );

  useEffect(() => {
    if (!dataUrl) return;

    getTopTierDistributionDataInsight(dataUrl);
    // eslint-disable-next-line
  }, [dataUrl]);

  return (
    <Container>
      <ChartWrapper label='Performance Tier Distribution' maxWidth='100%'>
        <HeaderArea>
          <Header>Performance History</Header>

          <ControlArea>
            <PerformanceChartFilter setDataUrl={setDataUrl} dataUrl={dataUrl} />
          </ControlArea>
        </HeaderArea>

        <StackedBarChart
          key={
            topTierDistributionData && topTierDistributionData.length > 0
              ? `${topTierDistributionData.length}`
              : 'empty'
          }
          data={topTierDistributionData}
          xAxisDataKey='monthName'
          series={[
            {
              dataKey: 'platinumCount',
              label: 'Platinum',
              color: theme.palette.blueColor,
            },
            {
              dataKey: 'goldCount',
              label: 'Gold',
              color: theme.palette.goldYellow,
            },
            {
              dataKey: 'silverCount',
              label: 'Silver',
              color: theme.palette.mediumNeutralGray,
            },
            {
              dataKey: 'riskCount',
              label: 'At risk',
              color: theme.palette.errorRed,
            },
          ]}
          aspect={5}
          barSize={36}
          categoryGap='25%'
          legendOrder='normal'
          tooltipShowTotal={true}
          tooltipTotalLabel='Total'
          tooltipValueFormatter={(value) => value.toLocaleString()}
        />
      </ChartWrapper>
    </Container>
  );
};

export default PerformanceChart;

const Container = styled.div`
  width: 100%;
  grid-column: span 3;
`;

const ControlArea = styled.div`
  display: flex;
`;

const HeaderArea = styled.div`
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  /* border: 1px solid red; */
  margin-bottom: 18px;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`;
